import { Vue, Component } from 'vue-property-decorator';
import { toI18n } from '@/utils/commonUtils';

@Component
export default class Groups extends Vue {
  public allGroups = [
    { code: 'introduction', name: this.toI18n('TERMS_MIXINS_MSG3') },// 쇼핑몰/회사소개
    { code: 'access', name: this.toI18n('TERMS_MIXINS_MSG4') },// 이용약관
    { code: 'e-commerce', name: this.toI18n('TERMS_MIXINS_MSG5') },// 전자금융거래이용약관
    { code: 'personal-info', name: this.toI18n('TERMS_MIXINS_MSG6') },// 개인정보처리방침
    { code: 'collection', name: this.toI18n('TERMS_MIXINS_MSG7') },// 개인정보 수집/동의 항목
    { code: 'withdrawal', name: this.toI18n('TERMS_MIXINS_MSG8') }// 이용/탈퇴안내
  ];
  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t(needToI18nStr));
  }
}